import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ChatPage from './chat-page';
import GlobalStyle from './globel-style';
import RedirectMessage from './components/RedirectMessage';
import EmployerCheckPage from './components/EmployerCheckPage';

function App() {
  return (
    <>
      <GlobalStyle></GlobalStyle>
      <Router>
        <Routes>
          <Route path="/chat/:apikey" element={<ChatPage />} />
          {/* Shareable page the candidate forwards to their employer. */}
          <Route path="/employer-check/:apikey" element={<EmployerCheckPage />} />
          {/* Assessment-first entry for adverts. Same widget, same branding and
              layouts — it just starts at the questionnaire instead of the
              identification chat, and only asks for contact details if the
              visitor chooses to speak to an adviser. */}
          <Route path="/assess/:apikey/:type" element={<ChatPage />} />
          <Route path="/assess/:apikey" element={<ChatPage />} />
          <Route path="*" element={<RedirectMessage />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
